module.exports = __webpack_public_path__ + "img/wjsc.e6c3feb5.png";